export default __webpack_public_path__ + "static/ramanSharma8-cd1d542fee8afdb8e05a44e6ace48d8f.jpg";